import { writable, get } from 'svelte/store'
import { firebase } from '../firebase'
import db from "../firebase";
import { navigate } from "svelte-routing";
let alerta = 'Error del servidor, vuelva a intentarlo'
import {auth} from '../firebase'
import {user} from './user'
import {
  modalStore,
  error404,
  proces200,
  proces401
} from './service'
// Obtén la fecha actual
export const preguntas = writable([]);
const fechaActual = new Date();
// Primero, establece la fecha en el primer día del mes actual
const fecha1 = new Date(fechaActual.getFullYear(), fechaActual.getMonth(), 1);


// Obtén el año, mes y día por separado
export const año1 = fecha1.getFullYear();
const mes1 = String(fecha1.getMonth() + 1).padStart(2, '0'); // Agrega ceros al principio si es necesario
const dia1 = String(fecha1.getDate()).padStart(2, '0'); // Agrega ceros al principio si es necesario

// Combina los valores para obtener el formato "AAAA-MM-DD"
export let fechaFormateada1 = `${año1}-${mes1}-${dia1}`;


export const createNewDate = () => {
  const currentDate = new Date();
  return {
    currentDate:currentDate,
    year:currentDate.getFullYear(),
    month:String(currentDate.getMonth() + 1).padStart(2, '0'),
    day:String(currentDate.getDate()).padStart(2, '0')
  }
}

export const printdate = (currentDate) => {
  return `${String(currentDate.getDate()).padStart(2, '0')}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${currentDate.getFullYear()}`;
}

export async function addDoc(data) {
  try {
    const docRef = await db.collection(data.collection).add(data.data);
    navigate('/panel', { replace: true })
    proces200();
  } catch (error) {
    console.error('Error al agregar el documento:', error);
    alert(alerta);
  }
}


/* addDoc(newData); */

export async function CrearMuestra(item) {

    try {
      if(item.objeto !== undefined){
        const docRef = await db.collection("muestras").add({ fecha: firebase.firestore.Timestamp.fromDate(new Date()), objeto:item.objeto,displayName: item.displayName, photoURL:item.photoURL });
        proces200();
      }else{
        const docRef = await db.collection("muestras").add({ fecha: firebase.firestore.Timestamp.fromDate(new Date()),displayName: item.displayName,photoURL: item.photoURL});
      }
    } catch (error) {
      console.error('Error al agregar el documento:', error)
      error404();
    }
  
    if(!item.userRol){
      
      cerrarSecion();
    }else{
      
      navigate('/dashboard', { replace: true })
    }
}

function cerrarSecion(){
  auth.signOut();
  user.setUser(null);
}

// Función para leer los documentos de la colección "preguntas"
export function leerpreguntas() {
  // Realiza la consulta a la colección "preguntas"
  db.collection("preguntas").onSnapshot(querySnapshot => {
    const preguntasArr = [];
    querySnapshot.forEach(doc => {
      const data = { id: doc.id, ...doc.data() };
      preguntasArr.push(data);
    })
    // Ordenar el arreglo de objetos en base al campo "valor"
    preguntasArr.sort((a, b) => a.nPregunta - b.nPregunta);
    preguntas.set(preguntasArr);
  })
}

export const muestras = writable([]);
// Función para leer los documentos de la colección "preguntas"
export function leermuestras() {
  
}

export async function eliminarDocumento(documentId) {
  try {
    await db.collection('preguntas').doc(documentId).delete();
  } catch (error) {
    console.error('Error al eliminar el documento:', error);
    error404();
    
  }
}

export async function eliminarMuestra(documentId) {
  try {
    await db.collection('muestras').doc(documentId).delete();
    
    bItems(fechaFormateada1, fechaFormateada2)
    proces200();
  } catch (error) {
    console.error('Error al eliminar el documento:', error);
    error404();
    
  }
}

export async function delDoc(data){
  try {
    await db.collection(data.collection).doc(data.id).delete();
    proces200();
  } catch (error) {
    error404();
  }
   }

export async function updateD(data){
  try {
       const mesaRef = db.collection(data.collection).doc(data.id);
       await mesaRef.update(data.data);
       proces200();
       
     } catch (error) {
       console.error("Error al actualizar el estado de la mesa:", error);
       error404();
     }
  
   }

export async function updateDoc(coleccion, doc, data) {
  console.log("data",data)
  var Ref = db.collection(coleccion).doc(doc);

  await Ref.update(data)
    .then(() => {
      navigate('/panel', { replace: true })
    })
    .catch((error) => {
      console.error("Error updating document: ", error);
      error404();
    });
}

export async function updateDocm(coleccion, doc, data) {

  var Ref = db.collection(coleccion).doc(doc);



  await Ref.update({ mesa: data })
    .then(() => {

      navigate('/panel', { replace: true })

    })
    .catch((error) => {
      // The document probably doesn't exist.
      console.error("Error updating document: ", error);
      error404();
    });

}



let a = 5


// Luego, establece la fecha en el último día del mes actual
// Para esto, avanza un mes y retrocede un día desde el primer día del siguiente mes
const fecha2 = new Date(fechaActual.getFullYear(), fechaActual.getMonth() + 1, 0);
// Obtén el año, mes y día por separado
const año2 = fecha2.getFullYear();
const mes2 = String(fecha2.getMonth() + 1).padStart(2, '0');
 // Agrega ceros al principio si es necesario
const dia2 = String(fecha2.getDate()).padStart(2, '0'); 
// Agrega ceros al principio si es necesario
// Combina los valores para obtener el formato "AAAA-MM-DD"
export let fechaFormateada2 = `${año2}-${mes2}-${dia2}`;

export function bItems(fechaInicio, fechaFin) {

  const fechaI = new Date(fechaInicio);
  const fechaF = new Date(fechaFin);
  db.collection('muestras')
    .where('fecha', '>=', fechaI)
    .where('fecha', '<=', fechaF)
    .orderBy('fecha')
    .get()
    .then((querySnapshot) => {
      const muestraArr = [];
      querySnapshot.forEach((doc) => {
        const data = { id: doc.id, ...doc.data() };
        muestraArr.push(data);
      });
      /* console.log('muestras',muestraArr) */
      muestras.set(muestraArr);
      if(0<muestraArr.length){
        /* proces401(); */
      }
    })
    .catch((error) => {
      console.error('Error al consultar documentos: ', error);
      error404();
    });
}



export async function agregarMultiplesDocumentosAColeccion(coleccion, documentos) {
  const db = firebase.firestore();

  try {
    for (let i = 0; i < documentos.length; i++) {
      const dato = documentos[i];

      await db.collection(coleccion).set(dato);
    }
  }
  catch (error) {
    console.error('Error al agregar documentos:', error);
    error404();
  }
}

export async function eliminarDocumentosDeColeccion(coleccion, dataList) {
  const db = firebase.firestore();

  try {
    const querySnapshot = await db.collection(coleccion).get();

    const batch = db.batch();
    querySnapshot.forEach((doc) => {
      batch.delete(doc.ref);
    });

    await batch.commit();
    agregarMultiplesDocumentosAColeccion(coleccion, dataList);
    proces200();
  } catch (error) {
    console.error('Error al eliminar documentos:', error);
    error404();
  }
}